import React from 'react';
import { Form } from 'antd';

export const CustomRow = (props) => {
    return <div className={`msgIptRow ${props.divider ? "divider" : ""}`}>
        {
            props.title
                ? <div className="msgIptRowTitle">{props.title}</div>
                : null
        }
        <div className="msgIptRowCnt">
            <div className="msgIptCol" style={props.colStyle || {}}>
                {props.children}
            </div>
        </div>
    </div>
}

export const CustomCol = (props) => {
    let required = props.required === undefined ? true : props.required;
    return <Form.Item style={{
        width: props.width || "auto",
        height: props.height || "auto",
    }}>
        <div className="msgIptBlock">
            {
                props.label
                    ? <div className={`msgIptBlockLabel ${required === 'none' ? '' : required ? ' xinxin xinxinColor' : ' xinxin'}`} style={props.labelStyle || {}}>{props.label}</div>
                    : null
            }
            <div className="msgIptBlockInput" style={props.colStyle || {}}>
                {props.children}
                {
                    props.subfix
                        ? <div className="msgIptBlockInputFix" style={{ right: props.subfixRight || 10 , left: props.subfixLeft || 'none' }} onClick={props.savefn}>{props.subfix}</div>
                        : null
                }
            </div>
        </div>
    </Form.Item >
}


// WEBPACK FOOTER //
// ./src/components/Custom/index.js